<mat-card class="faq-card" *ngIf="isFaqOpen()" [class.faq-expanded]="isFaqExpanded()">
  <!-- Header -->
  <div class="faq-header">
    <div class="faq-title">
      <mat-icon class="faq-icon" svgIcon="icon-faq"></mat-icon>
      <span>{{ 'FAQ.TITLE' | i18nTranslate }}</span>
    </div>

    <div class="faq-header-actions">
      <button mat-icon-button (click)="expandFaq()">
        <mat-icon>{{ isFaqExpanded() ? "close_fullscreen" : "open_in_full" }}</mat-icon>
      </button>

      <button mat-icon-button (click)="toggleFaq()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- FAQ items -->
  <mat-accordion [class.faq-max-expanded]="isFaqExpanded()" (scroll)="onFaqScroll($event)">
    <mat-expansion-panel *ngFor="let faq of faqs">
      <mat-expansion-panel-header>
        <mat-panel-title> {{ faq.question | i18nTranslate }} </mat-panel-title>
      </mat-expansion-panel-header>
      <p>{{ faq.answer | i18nTranslate }}</p>
    </mat-expansion-panel>
    <div *ngIf="isLoading()" class="loading">
      Loading more…
    </div>
  </mat-accordion>

  <!-- Footer -->
  <div class="faq-footer">
    <div class="footer-text">
      <span>{{ 'FAQ.STILL_NEED_HELP' | i18nTranslate }}</span>
      <span class="additional-help"
        >{{ 'FAQ.CONTACT_AGENT' | i18nTranslate }}</span
      >
    </div>

    <div class="agent">
      <img src="assets/images/generic-agent.svg" [alt]="agentDetails?.userName || ('FAQ.AGENT_NAME' | i18nTranslate)" />
      <div class="agent-info">
        <span class="name">{{ agentDetails?.userName || ('FAQ.AGENT_NAME' | i18nTranslate) }}</span>
        <div class="actions">
          <mat-icon
            mat-icon-button
            fontSet="material-icons-outlined"
            (click)="copyAndCall()"
            (keydown.enter)="copyAndCall()"
            (keydown.space)="copyAndCall()"
            >call</mat-icon
          >
          <mat-icon
            mat-icon-button
            fontSet="material-icons-outlined"
            (click)="copyAndEmail()"
            (keydown.enter)="copyAndEmail()"
            (keydown.space)="copyAndEmail()"
            >email</mat-icon
          >
        </div>
      </div>
    </div>
  </div>
</mat-card>

<mat-icon
  mat-icon-button
  class="help-btn"
  svgIcon="icon-faq"
  (keydown.enter)="toggleFaq()"
  (keydown.space)="toggleFaq()"
  (click)="toggleFaq()"
></mat-icon>
